import { Route } from '@angular/router';
import { StatisticsPage } from '../pages/statistics/statistics.page';

export const StatisticsRoutes: Route[] = [
  {
    path: 'statistics',
    component: StatisticsPage,
  },
];
